export default "__VITE_ASSET__fc4b6a59__"